import React, {Component} from 'react';
import ProfileForm from '../../components/Profile';
import { Auth } from "aws-amplify";
import { pipe, sortBy, prop, filter, reverse, clone, equals } from 'ramda';
import { logError, updateInPath } from '../../../../common/utils';

export default class Profile extends Component {
  constructor(props) {
    super();

    this.state = {
      userAttributes: {},
      origAttributes: {},
      error: '',
      success: false
    };

    this.user = null;
  }

  parseCognitoAttributesToJson = (arr, userAttr) => {
    return pipe(
      clone,
      filter(({ Name }) => userAttr.includes(Name)),
      sortBy(prop('Name')),
      reverse
    )(arr);
  }

  fetchData = async () => {
    try {
      this.user  = await Auth.currentAuthenticatedUser();
      this.setState(prevState => updateInPath(prevState, 'userAttributes', this.user.attributes));
    } catch (err) {
      logError(err);
    }
  }

  handleSave = async () => {   
    try {
      await Auth.updateUserAttributes(this.user, this.state.userAttributes);
      this.setState(prevState => updateInPath(prevState, 'error', ''));
      this.setState(prevState => updateInPath(prevState, 'success', true));
      this.fetchData();
    } catch(err) {
      logError(err);
      this.setState(prevState => updateInPath(prevState, 'error', err.code));
      this.setState(prevState => updateInPath(prevState, 'success', false));
    }
  }

  handleCancel = () => {
    this.setState(prevState => updateInPath(prevState, 'userAttributes', this.user.attributes));
  }

  handleChange = (e, { name, value }) => {
    this.setState(prevState => updateInPath(prevState, 'userAttributes.' + name , value));
  }

  handleUpdateCountry = (e, { name, value }) => {
    if (value !== 'ee') {
      this.setState(prevState => updateInPath(prevState, 'userAttributes.custom:county_of_residence', ''));
    }

    this.setState(prevState => updateInPath(prevState, 'userAttributes.' + name, value));
  }

  // TODO: this should be somewhere under common profile data validator
  canSaveProfileData = () => {
    const attr = this.state.userAttributes;

    if (!attr.given_name || !attr.family_name) {
      return false;
    } else if (!attr['custom:phone_number']) {
      return false;
    } else if (!attr['custom:occupation'] || !attr['custom:occupation_details']) {
      return false;
    } else if (!attr['custom:year_of_birth'] || !attr['custom:country_of_residence']) {
      return false;
    } else if (attr['custom:country_of_residence'] === 'ee' && !attr['custom:county_of_residence']) {
      return false;
    }

    return true;
  };

  dataHasChanged = () => {
    return !this.user ? false : !equals(this.state.userAttributes, this.user.attributes);
  }

  componentDidMount() {
    this.fetchData();
  }

  // TODO error/success v2li!
  render() {
    const cancelEnabled = this.dataHasChanged(),
          saveEnabled = (cancelEnabled && this.canSaveProfileData());
          
    return (
      this.user &&
      <ProfileForm
        data={this.state.userAttributes}
        onChange={this.handleChange}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
        saveEnabled={saveEnabled}
        cancelEnabled={cancelEnabled}
        error={this.state.error}
        success={this.state.success}
        onUpdateCountry={this.handleUpdateCountry}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/user/containers/Profile/index.js